import { getExpiryColor, getExpiryLabel } from '../lib/utils'

interface ExpiryBadgeProps {
  days: number
  label?: string
}

export function ExpiryBadge({ days, label }: ExpiryBadgeProps) {
  const textLabel = label || getExpiryLabel(days)
  return (
    <span className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium ${getExpiryColor(days)}`}>
      {textLabel}
    </span>
  )
}
